import { Client, ClientLite } from '@lockton-apps/shared/interfaces';

export function toClientLite(client: Client): ClientLite {
  return {
    id: client.id,
    insuredName: client.clientData.insuredName,
  };
}
